import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

const ExactMatchBadge = () => (
  <BadgeRoot>
    <FormattedMessage id="exactMatch" defaultMessage="Exact match" />
  </BadgeRoot>
);

const BadgeRoot = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  height: 20,
  padding: '0 8px',
  borderRadius: theme.radii.md,
  fontSize: '10px',
  fontWeight: 600,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  backgroundColor: theme.palette.green50,
  border: `2px solid ${theme.palette.green400}`,
  color: theme.palette.green700,
}));

export default ExactMatchBadge;
